export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14009.08a62c65.jpg";